module.exports = __webpack_public_path__ + "static/media/icone.6a9297b3.jpg";